import styled, { css } from "styled-components";

export const WrapStyle = styled.div<{ noBorderTop?: boolean }>`
  padding-bottom: 4rem;

  ${({ theme, noBorderTop }) =>
    !noBorderTop &&
    css`
      border-top: 0.4rem solid ${theme.color.stroke.primary};
    `}
  border-bottom: 0.1rem solid ${({ theme }) => theme.color.stroke.light};

  display: flex;
  flex-direction: column;
  gap: 2rem;

  ${({ theme }) => theme.media.small} {
    gap: 2.8rem;
  }
`;

export const HeaderStyle = styled.header``;
